import api from '@/api';
import { dateFormat, saveParamsToQuery } from '@/utils/helpers';

let currentTicketListRequest = null;

const clarifications = {
  namespaced: true,

  state() {
    return {
      isLoading: true,
      filterParams: {
        objectName: '',
        region: '',
        number: '',
        date: '',
        customerName: '',
      },
      filterParamsHistory: [],
      search: '',
      list: {
        clarifications: [],
        pageCount: 0,
        page: 0,
      },
      protocolDetailErrorText: '',
      protocolDetail: null,
    };
  },

  mutations: {
    setFilterParams(state, params) {
      state.filterParams = params.result;
    },

    setPage(state, page) {
      state.list.page = page;
    },

    setSelectedFilters(state, params) {
      state.selectedFilters = params;
    },

    setSelectedFiltersHistory(state, params) {
      state.selectedFiltersHistory = params;
    },

    clearSelectedFiltersHistory(state) {
      state.selectedFiltersHistory = {};
    },

    setSearch(state, value) {
      state.search = value;
    },

    setList(state, data) {
      state.list = { ...data.result };
    },

    changeLoading(state, status) {
      state.isLoading = status;
    },
  },

  actions: {
    async setSearch({ commit, dispatch }, value) {
      commit('setSearch', value);
      commit('setPage', 1);
      await dispatch('loadList');
    },
    async setPage({ commit, dispatch }, page) {
      commit('setPage', page);
      await dispatch('loadList');
    },
    async loadList({
      state, commit, rootState, rootGetters,
    }) {
      commit('changeLoading', true);

      try {
        if (currentTicketListRequest) {
          return;
        }
        const { isLoggedIn } = rootState.user;
        const role = rootGetters['user/getPriorityRole']('supplier');
        if (!role && isLoggedIn) {
          return;
        }

        const params = {
          pageSize: 10,
        };

        currentTicketListRequest = api.clarifications[role].list(params);
        const { data } = await currentTicketListRequest;
        saveParamsToQuery({ page: params.page, search: params.search });
        commit('setList', data);
        currentTicketListRequest = null;
      } catch (e) {
        currentTicketListRequest = null;
        console.log(e);
      } finally {
        commit('changeLoading', false);
      }
    },
  },
};

export default clarifications;
